import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/chevron-down.svg'


const _withScopeId = n => (_pushScopeId("data-v-55a4b3db"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown gsalt-dropdown" }
const _hoisted_2 = {
  key: 0,
  class: "text-md"
}
const _hoisted_3 = {
  key: 1,
  class: "text-md placeholder"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = ["onClick"]

import { DropdownValue } from '@/types/Dropdown'


export default /*#__PURE__*/_defineComponent({
  props: {
    currentValue: null,
    placeholder: null,
    values: null,
    disabled: { type: Boolean }
  },
  emits: ['select-item'],
  setup(__props: any, { emit }) {

const props = __props as {
  currentValue: string | null
  placeholder: string
  values: DropdownValue[]
  disabled: boolean
}





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["btn dropdown-toggle", { disable: props.disabled }]),
      type: "button",
      id: "dropdownMenuButton1",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, [
      (props.currentValue)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.currentValue), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(props.placeholder), 1)),
      _hoisted_4
    ], 2),
    (props.values.length > 0)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: _normalizeClass(["dropdown-menu", { 'd-none': props.disabled }]),
          "aria-labelledby": "gsaltDropdown"
        }, [
          _createElementVNode("li", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.values, (value) => {
              return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(["dropdown-item text-md", { isUsed: value.isUsed }]),
                onClick: ($event: any) => (emit('select-item', value.id)),
                key: value.id
              }, _toDisplayString(value.name), 11, _hoisted_5))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})